import { Component, ChangeDetectionStrategy, input } from '@angular/core';

@Component({
  selector: 'app-basic-card',
  templateUrl: './basic-card.component.html',
  styleUrls: ['./basic-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BasicCardComponent {
  /** The name of the field to be displayed (required)*/
  fieldName = input<string>();

  /** The reading from the field (optional) */
  fieldReading = input<string | undefined>(undefined);
}
